import { Injectable } from '@angular/core';
import { MatDateFormats } from '@angular/material/core';

type DisplayFormats = MatDateFormats['display'];
type ParseFormats = MatDateFormats['parse'];

@Injectable()
export class DynamicFormatDate {
  private parseMap: ParseFormats = {
    dateInput: 'dd-MM-yyyy',
  };

  private displayMap: DisplayFormats = {
    dateInput: 'dd-MM-yyyy',
    monthLabel: 'MMMM',
    monthYearLabel: 'yyyy MMMM',
    dateA11yLabel: 'MMMM d yyyy',
    monthYearA11yLabel: 'MMMM yyyy',
  };

  get parse(): ParseFormats {
    return this.parseMap;
  }

  get display(): DisplayFormats {
    return this.displayMap;
  }

  setParseFormat(format: Partial<ParseFormats>): void {
    this.parseMap = { ...this.parseMap, ...format };
  }

  setDisplayFormat(format: Partial<DisplayFormats>): void {
    this.displayMap = { ...this.displayMap, ...format };
  }
}
